import { compareDates, contractDeadline, type NoticeTerm } from './noticeTerms';

/**
 * The notice terms the customer confirmed from their contract, beside the date PayRight calculated.
 * PayRight does not track these; the page says so, and says where the two differ.
 */
export function ContractNoticeTerms({ terms, firstFurnishingDate, statutoryDate, formatDate }: {
  terms: NoticeTerm[]; firstFurnishingDate?: string | null; statutoryDate?: string | null; formatDate: (date: string) => string;
}) {
  if (!terms.length) return null;
  return <section className="workspace-section" aria-labelledby="contract-terms-heading">
    <div className="section-heading"><div><h2 id="contract-terms-heading">Notice terms in your contract</h2>
      <p>You confirmed these from your contract. They are separate from the notice PayRight prepares, and PayRight does not track them or count days for them. Check them with your attorney.</p></div></div>
    <ul className="contract-terms">{terms.map(term => {
      const date = contractDeadline(term, firstFurnishingDate);
      const comparison = date && statutoryDate ? compareDates(date, statutoryDate) : null;
      return <li key={term.summary}><strong>{term.summary}</strong>
        <small> From your contract: “{term.quote}”</small>
        {date && <p>Counted from your first day of work, that is {formatDate(date)}.{comparison && statutoryDate && <> PayRight’s date for its notice is {formatDate(statutoryDate)}. {
          comparison === 'EARLIER' ? 'Your contract’s date comes first, so it needs attention sooner.' : comparison === 'LATER' ? 'Your contract’s date comes after PayRight’s.' : 'The two dates are the same.'}</>}</p>}
        {term.kind === 'DEADLINE' && !date && <p>PayRight can’t place this on the calendar{term.dayType === 'BUSINESS' ? ' because it counts business days' : term.basis !== 'FIRST_WORK' ? ' because it does not start from your first day of work' : ' until you enter your first day of work'}.</p>}
        {term.kind === 'DELIVERY' && <p>PayRight’s notice may be delivered differently. Check that the way you send it meets this term.</p>}
      </li>; })}</ul>
  </section>;
}
